<script lang="ts">
  import { getServices } from '../../app/context';
  import { setTitle } from '../../model/ops';
  import { LIMITS } from '../../model/types';
  import { strings } from '../../strings';

  let { class: className }: { class?: string } = $props();

  const { store } = getServices();
</script>

<input
  type="text"
  aria-label={strings.yourName}
  placeholder={strings.yourName}
  maxlength={LIMITS.title}
  autocomplete="off"
  value={store.doc.title}
  class={[
    'h-9 min-w-0 rounded-lg border border-transparent bg-transparent px-2 text-base font-medium text-ink placeholder:font-normal placeholder:text-ink-muted hover:border-line focus:border-line-strong/70 focus:bg-surface sm:text-sm pointer-coarse:h-11',
    className,
  ]}
  oninput={(event) => {
    const value = event.currentTarget.value;
    store.apply((doc) => setTitle(doc, value), { coalesce: 'title' });
  }}
/>
